import { Typography } from '@mui/material';
import React from 'react';
import CreditHoldList from '../../components/CreditHolds/CreditHoldList';
import CreditHoldSettings from '../../components/CreditHolds/CreditHoldSettings';

const CreditHoldsPage = () => {
    return (
        <div>
            <Typography variant='h1'>Credit Hold Manager</Typography>
            <CreditHoldSettings />
            <CreditHoldList />
        </div>
    );
};

export default CreditHoldsPage;
